<div class="modal-header text-center">
  <div class="h5-text modal-title w-100" id="FirstLoginModalLabel">Our mobile app is now available!</div>
  <button type="button" class="close" (click)="activeModal.dismiss('Cross click')" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body text-center">
  <div class="row">
    <div class="col-lg-9 pb-3" style="line-height:300px">
      <div style="display: inline-block;padding:0 15px;width:30%">
        <img alt="Mobile App Snapshot 1" src="/assets/MobileApp-popup/MobileApp_1.png" style="vertical-align: middle;width:100%;max-width:150px">
      </div>
      <div style="display: inline-block;padding-right: 15px;width:40%">
        <img alt="Mobile App Snapshot 2" src="/assets/MobileApp-popup/MobileApp_2.png" style="vertical-align: middle;width:100%;max-width:200px">
      </div>
      <div style="display: inline-block;padding-right: 15px;width:30%">
        <img alt="Mobile App Snapshot 3" src="/assets/MobileApp-popup/MobileApp_3.png" style="vertical-align: middle;width:100%;max-width:150px">
      </div>
    </div>
    <div class="col-lg-3 pb-3">
      <h4 class="mt-5 d-none d-lg-block">Download</h4>
      <a href="{{config.mobileAppAndroidLink}}" target="_blank" aria-label="Mobile app on Android">
        <img alt="Google Play Icon" src="/assets/MobileApp-popup/GooglePlay.png" style="max-width:100%" class="m-2">
      </a>
      <a href="{{config.mobileAppIphoneLink}}" target="_blank" aria-label="Mobile app on Apple">
        <img alt="AppStore Icon" src="/assets/MobileApp-popup/AppStore.png" style="max-width:100%"class="m-2">
      </a>
    </div>
  </div>
</div>
